<script>
import BaseAvatar from "@/components/BaseAvatar/BaseAvatar.vue";

import ForumDisplayedNameUpdated from "@/components/News/NewsItemText/FORUM_DISPLAYED_NAME_UPDATED.vue";
import ForumUpdateAvatar from '@/components/News/NewsItemText/FORUM_UPDATE_AVATAR.vue';
import ForumUpdateCover from '@/components/News/NewsItemText/FORUM_UPDATE_COVER.vue';
import ForumUpdateNumberSeats from '@/components/News/NewsItemText/FORUM_UPDATE_NUMBER_SEATS.vue';
import CandidateValIsLost from '@/components/News/NewsItemText/CANDIDATE_VAL_IS_LOST.vue';
import CandidateValNew from '@/components/News/NewsItemText/CANDIDATE_VAL_NEW.vue';
import CandidateValNewV2 from '@/components/News/NewsItemText/CANDIDATE_VAL_NEW_V2.vue';
import CandidateValRevoked from '@/components/News/NewsItemText/CANDIDATE_VAL_REVOKED.vue';
import ElectedDuringTerm from '@/components/News/NewsItemText/ELECTED_DURING_TERM.vue';
import ElectedResumedDuringTerm from '@/components/News/NewsItemText/ELECTED_RESUMED_DURING_TERM.vue';
import ElectedResignedDuringTerm from '@/components/News/NewsItemText/ELECTED_RESIGNED_DURING_TERM.vue';
import ElectedResignedReplacedDuringTerm from '@/components/News/NewsItemText/ELECTED_RESIGNED_REPLACED_DURING_TERM.vue';
import ElectedVocationEnded from '@/components/News/NewsItemText/ELECTED_VACATION_ENDED.vue';
import ElectedVocationStarted from '@/components/News/NewsItemText/ELECTED_VACATION_STARTED.vue';
import ElectedValNew from '@/components/News/NewsItemText/ELECTED_VAL_NEW.vue';
import ElectedValNewV2 from '@/components/News/NewsItemText/ELECTED_VAL_NEW_V2.vue';
import ElectedValRbts from '@/components/News/NewsItemText/ELECTED_VAL_RBTS.vue';
import ElectedValRevoked from '@/components/News/NewsItemText/ELECTED_VAL_REVOKED.vue';
import ForumCandidateValLost from '@/components/News/NewsItemText/FORUM_CANDIDATE_VAL_LOST.vue';
import ForumCandidateValNew from '@/components/News/NewsItemText/FORUM_CANDIDATE_VAL_NEW.vue';
import ForumCandidateValNewV2 from '@/components/News/NewsItemText/FORUM_CANDIDATE_VAL_NEW_V2.vue';
import ForumElectedValNew from '@/components/News/NewsItemText/FORUM_ELECTED_VAL_NEW.vue';
import ForumElectedValNewV2 from '@/components/News/NewsItemText/FORUM_ELECTED_VAL_NEW_V2.vue';
import MemberCreated from '@/components/News/NewsItemText/MEMBER_CREATED.vue';
import MemberUpdateAbout from '@/components/News/NewsItemText/MEMBER_UPDATE_ABOUT.vue';
import MemberUpdateAboutEmpty from '@/components/News/NewsItemText/MEMBER_UPDATE_ABOUT_EMPTY.vue';
import MemberUpdateAvatar from '@/components/News/NewsItemText/MEMBER_UPDATE_AVATAR.vue';
import MemberUpdateCover from '@/components/News/NewsItemText/MEMBER_UPDATE_COVER.vue';
import MemberUpdateName from '@/components/News/NewsItemText/MEMBER_UPDATE_NAME.vue';
import MemberUpdateWebsite from '@/components/News/NewsItemText/MEMBER_UPDATE_WEBSITE.vue';
import MemberUpdateWebsiteEmpty from '@/components/News/NewsItemText/MEMBER_UPDATE_WEBSITE_EMPTY.vue';
import MemberTurnedIndependent from '@/components/News/NewsItemText/MEMBER_TURNED_INDEPENDENT.vue';
import MinisterNew from '@/components/News/NewsItemText/MINISTER_NEW.vue';
import MinisterRevoked from '@/components/News/NewsItemText/MINISTER_REVOKED.vue';
import OpinionChangedAndMadePublicByMember from '@/components/News/NewsItemText/OPINION_CHANGED_AND_MADE_PUBLIC_BY_MEMBER.vue';
import OpinionChangedAndMadePublicByOrg from '@/components/News/NewsItemText/OPINION_CHANGED_AND_MADE_PUBLIC_BY_ORG.vue';
import OpinionChangedByMember from '@/components/News/NewsItemText/OPINION_CHANGED_BY_MEMBER.vue';
import OpinionChangedByOrg from '@/components/News/NewsItemText/OPINION_CHANGED_BY_ORG.vue';
import OpinionCreatedByMember from '@/components/News/NewsItemText/OPINION_CREATED_BY_MEMBER.vue';
import OpinionCreatedByOrg from '@/components/News/NewsItemText/OPINION_CREATED_BY_ORG.vue';
import OpinionMemberConsolidated from '@/components/News/NewsItemText/OPINION_MEMBER_CONSOLIDATED.vue';
import OpinionNewMadePublicByMember from '@/components/News/NewsItemText/OPINION_NEW_MADE_PUBLIC_BY_MEMBER.vue';
import OpinionNewMadePublicByOrg from '@/components/News/NewsItemText/OPINION_NEW_MADE_PUBLIC_BY_ORG.vue';
import OpinionUpdatedByMember from '@/components/News/NewsItemText/OPINION_UPDATED_BY_MEMBER.vue';
import OpinionUpdatedByOrg from '@/components/News/NewsItemText/OPINION_UPDATED_BY_ORG.vue';
import OpinionUpdatedAndMadePublicByMember from '@/components/News/NewsItemText/OPINION_UPDATED_AND_MADE_PUBLIC_BY_MEMBER.vue';
import OpinionUpdatedAndMadePublicByOrg from '@/components/News/NewsItemText/OPINION_UPDATED_AND_MADE_PUBLIC_BY_ORG.vue';
import OpinionChangedByMemberSplit from '@/components/News/NewsItemText/OPINION_CHANGED_BY_MEMBER_SPLIT.vue';
import OpinionChangedByOrgSplit from '@/components/News/NewsItemText/OPINION_CHANGED_BY_ORG_SPLIT.vue';
import OpinionGeneratedByVotingMember from '@/components/News/NewsItemText/OPINION_GENERATED_BY_VOTING_MEMBER.vue';
import OpinionGeneratedByVotingOrg from '@/components/News/NewsItemText/OPINION_GENERATED_BY_VOTING_ORG.vue';
import OpinionArchivedMadePublic from '@/components/News/NewsItemText/OPINION_ARCHIVED_MADE_PUBLIC.vue';
import OpinionMadePrivate from '@/components/News/NewsItemText/OPINION_MADE_PRIVATE.vue';
import OrgCreated from '@/components/News/NewsItemText/ORG_CREATED.vue';
import OrgCreatedConsolidated from '@/components/News/NewsItemText/ORG_CREATED_CONSOLIDATED.vue';
import OrgUpdateAbout from '@/components/News/NewsItemText/ORG_UPDATE_ABOUT.vue';
import OrgUpdateAvatar from '@/components/News/NewsItemText/ORG_UPDATE_AVATAR.vue';
import OrgUpdateCover from '@/components/News/NewsItemText/ORG_UPDATE_COVER.vue';
import OrgUpdateName from '@/components/News/NewsItemText/ORG_UPDATE_NAME.vue';
import OrgUpdateWebsite from '@/components/News/NewsItemText/ORG_UPDATE_WEBSITE.vue';
import PartyApplicationReceived from '@/components/News/NewsItemText/PARTY_APPLICATION_RECEIVED.vue';
import PartyCreated from '@/components/News/NewsItemText/PARTY_CREATED.vue';
import PartyUpdatedName from '@/components/News/NewsItemText/PARTY_UPDATED_NAME.vue';
import PartyUpdatedWebsite from '@/components/News/NewsItemText/PARTY_UPDATED_WEBSITE.vue';
import PrimeMinisterNew from '@/components/News/NewsItemText/PRIME_MINISTER_NEW.vue';
import ProposalCommitteeDecision from '@/components/News/NewsItemText/PROPOSAL_COMMITTEE_DECISION.vue';
import ProposalPublishBy2 from '@/components/News/NewsItemText/PROPOSAL_PUBLISH_BY_2.vue';
import ProposalPublishBy2Approved from '@/components/News/NewsItemText/PROPOSAL_PUBLISH_BY_2_APPROVED.vue';
import ProposalPublishBy2Referred from '@/components/News/NewsItemText/PROPOSAL_PUBLISH_BY_2_REFERRED.vue';
import ProposalPublishByMember from '@/components/News/NewsItemText/PROPOSAL_PUBLISH_BY_MEMBER.vue';
import ProposalPublishByMemberApproved from '@/components/News/NewsItemText/PROPOSAL_PUBLISH_BY_MEMBER_APPROVED.vue';
import ProposalPublishByMemberReferred from '@/components/News/NewsItemText/PROPOSAL_PUBLISH_BY_MEMBER_REFERRED.vue';
import ProposalPublishByMultiple from '@/components/News/NewsItemText/PROPOSAL_PUBLISH_BY_MULTIPLE.vue';
import ProposalPublishByMultipleApproved from '@/components/News/NewsItemText/PROPOSAL_PUBLISH_BY_MULTIPLE_APPROVED.vue';
import ProposalPublishByMultipleReferred from '@/components/News/NewsItemText/PROPOSAL_PUBLISH_BY_MULTIPLE_REFERRED.vue';
import ProposalPublishByOrg from '@/components/News/NewsItemText/PROPOSAL_PUBLISH_BY_ORG.vue';
import ProposalPublishByOrgApproved from '@/components/News/NewsItemText/PROPOSAL_PUBLISH_BY_ORG_APPROVED.vue';
import ProposalPublishByOrgReferred from '@/components/News/NewsItemText/PROPOSAL_PUBLISH_BY_ORG_REFERRED.vue';
import ProposalRiksdagenDecision from '@/components/News/NewsItemText/PROPOSAL_RIKSDAGEN_DECISION.vue';
import ProposalSplit from '@/components/News/NewsItemText/PROPOSAL_SPLIT.vue';
import ProposalVotingProvided from '@/components/News/NewsItemText/PROPOSAL_VOTING_PROVIDED.vue';
import ProposalTorchPassed from '@/components/News/NewsItemText/PROPOSAL_TORCH_PASSED.vue';
import ProposalUpdatedMajor from '@/components/News/NewsItemText/PROPOSAL_UPDATED_MAJOR.vue';
import ProposalUpdatedMinor from '@/components/News/NewsItemText/PROPOSAL_UPDATED_MINOR.vue';

// CONSOLIDATED
import CandidateValNewConsolidated from '@/components/News/NewsItemText/CANDIDATE_VAL_NEW_CONSOLIDATED.vue';
import ElectedValNewConsolidated from '@/components/News/NewsItemText/ELECTED_VAL_NEW_CONSOLIDATED.vue';
import MemberCreatedConsolidated from '@/components/News/NewsItemText/MEMBER_CREATED_CONSOLIDATED.vue';
import OpinionOrgConsolidated from '@/components/News/NewsItemText/OPINION_ORG_CONSOLIDATED.vue';
import PartyApplicationReceivedConsolidated from '@/components/News/NewsItemText/PARTY_APPLICATION_RECEIVED_CONSOLIDATED.vue';
import PartyCreatedConsolidated from '@/components/News/NewsItemText/PARTY_CREATED_CONSOLIDATED.vue';
import PartyUpdatedNameConsolidated from '@/components/News/NewsItemText/PARTY_UPDATED_NAME_CONSOLIDATED.vue';
import PartyUpdatedWebsiteConsolidated from '@/components/News/NewsItemText/PARTY_UPDATED_WEBSITE_CONSOLIDATED.vue';
import ProposalPublishBy2Consolidated from '@/components/News/NewsItemText/PROPOSAL_PUBLISH_BY_2_CONSOLIDATED.vue';
import ProposalPublishByMemberConsolidated from '@/components/News/NewsItemText/PROPOSAL_PUBLISH_BY_MEMBER_CONSOLIDATED.vue';
import ProposalPublishByMultipleConsolidated from '@/components/News/NewsItemText/PROPOSAL_PUBLISH_BY_MULTIPLE_CONSOLIDATED.vue';
import ProposalPublishByOrgConsolidated from '@/components/News/NewsItemText/PROPOSAL_PUBLISH_BY_ORG_CONSOLIDATED.vue';
import ProposalPublishByMemberConsolidatedDifferent from '@/components/News/NewsItemText/PROPOSAL_PUBLISH_BY_MEMBER_CONSOLIDATED_DIFFERENT.vue';
import ProposalPublishByOrgConsolidatedDifferent from '@/components/News/NewsItemText/PROPOSAL_PUBLISH_BY_ORG_CONSOLIDATED_DIFFERENT.vue';
import ProposalCommitteeDecisionConsolidated from '@/components/News/NewsItemText/PROPOSAL_COMMITTEE_DECISION_CONSOLIDATED.vue';
import ProposalRiksdagenDecisionConsolidated from '@/components/News/NewsItemText/PROPOSAL_RIKSDAGEN_DECISION_CONSOLIDATED.vue';

export default {
  name: "NewsItem",
  props: {
    itemData: {
      type: Object
    }
  },
  components: {
    BaseAvatar,
    ForumDisplayedNameUpdated,
    ForumUpdateAvatar,
    ForumUpdateCover,
    ForumUpdateNumberSeats,
    CandidateValIsLost,
    CandidateValNew,
    CandidateValNewV2,
    CandidateValRevoked,
    ElectedResumedDuringTerm,
    ElectedResignedDuringTerm,
    ElectedResignedReplacedDuringTerm,
    ElectedDuringTerm,
    ElectedVocationEnded,
    ElectedVocationStarted,
    ElectedValNew,
    ElectedValNewV2,
    ElectedValRbts,
    ElectedValRevoked,
    ForumCandidateValNew,
    ForumCandidateValNewV2,
    ForumCandidateValLost,
    ForumElectedValNew,
    ForumElectedValNewV2,
    MemberCreated,
    MemberUpdateAbout,
    MemberUpdateAboutEmpty,
    MemberUpdateAvatar,
    MemberUpdateCover,
    MemberUpdateName,
    MemberUpdateWebsite,
    MemberUpdateWebsiteEmpty,
    MemberTurnedIndependent,
    MinisterNew,
    MinisterRevoked,
    OpinionChangedAndMadePublicByMember,
    OpinionChangedAndMadePublicByOrg,
    OpinionChangedByMember,
    OpinionChangedByOrg,
    OpinionCreatedByMember,
    OpinionCreatedByOrg,
    OpinionMemberConsolidated,
    OpinionNewMadePublicByMember,
    OpinionNewMadePublicByOrg,
    OpinionUpdatedByMember,
    OpinionUpdatedByOrg,
    OpinionUpdatedAndMadePublicByMember,
    OpinionUpdatedAndMadePublicByOrg,
    OpinionChangedByMemberSplit,
    OpinionChangedByOrgSplit,
    OpinionGeneratedByVotingMember,
    OpinionGeneratedByVotingOrg,
    OpinionArchivedMadePublic,
    OpinionMadePrivate,
    OrgCreated,
    OrgCreatedConsolidated,
    OrgUpdateAbout,
    OrgUpdateAvatar,
    OrgUpdateCover,
    OrgUpdateName,
    OrgUpdateWebsite,
    PartyApplicationReceived,
    PartyCreated,
    PartyUpdatedName,
    PartyUpdatedWebsite,
    PrimeMinisterNew,
    ProposalCommitteeDecision,
    ProposalPublishBy2,
    ProposalPublishBy2Approved,
    ProposalPublishBy2Referred,
    ProposalPublishByMember,
    ProposalPublishByMemberApproved,
    ProposalPublishByMemberReferred,
    ProposalPublishByMultiple,
    ProposalPublishByMultipleApproved,
    ProposalPublishByMultipleReferred,
    ProposalPublishByOrg,
    ProposalPublishByOrgApproved,
    ProposalPublishByOrgReferred,
    ProposalRiksdagenDecision,
    ProposalSplit,
    ProposalVotingProvided,
    ProposalTorchPassed,
    ProposalUpdatedMajor,
    ProposalUpdatedMinor,

    // CONSOLIDATED
    CandidateValNewConsolidated,
    ElectedValNewConsolidated,
    MemberCreatedConsolidated,
    OpinionOrgConsolidated,
    PartyApplicationReceivedConsolidated,
    PartyCreatedConsolidated,
    PartyUpdatedNameConsolidated,
    PartyUpdatedWebsiteConsolidated,
    ProposalPublishBy2Consolidated,
    ProposalPublishByMemberConsolidated,
    ProposalPublishByMultipleConsolidated,
    ProposalPublishByOrgConsolidated,
    ProposalPublishByMemberConsolidatedDifferent,
    ProposalPublishByOrgConsolidatedDifferent,
    ProposalCommitteeDecisionConsolidated,
    ProposalRiksdagenDecisionConsolidated,
  },
  computed: {
    newsType() {
      return this.itemData.textType;
    },
    privacyIcon() {
      return `${this.itemData.newsPrivacy}-news-privacy`
    }
  }
}
</script>

<template>
  <div class="news-wrapper" :data-news-type="newsType">
    <div class="news-element">
      <base-avatar :img-src="itemData.sender"
                   size="52"
                   class="user-news-avatar"
      />
      <div class="news-content">
        <div class="news-text">
          <template v-if="newsType === 'FORUM_DISPLAYED_NAME_UPDATED'">
            <forum-displayed-name-updated :news="itemData"/>
          </template>
          <template v-if="newsType === 'FORUM_UPDATE_AVATAR'">
            <forum-update-avatar :news="itemData"/>
          </template>
          <template v-if="newsType === 'FORUM_UPDATE_COVER'">
            <forum-update-cover :news="itemData"/>
          </template>
          <template v-if="newsType === 'FORUM_UPDATE_NUMBER_SEATS'">
            <forum-update-number-seats :news="itemData"/>
          </template>
          <template v-if="newsType === 'CANDIDATE_VAL_IS_LOST'">
            <candidate-val-is-lost :news="itemData"/>
          </template>
          <template v-else-if="newsType === 'CANDIDATE_VAL_NEW'">
            <candidate-val-new :news="itemData"/>
          </template>
          <template v-else-if="newsType === 'CANDIDATE_VAL_NEW_V2'">
            <candidate-val-new-v2 :news="itemData"/>
          </template>
          <template v-else-if="newsType === 'CANDIDATE_VAL_REVOKED'">
            <candidate-val-revoked :news="itemData"/>
          </template>
          <template v-else-if="newsType === 'ELECTED_DURING_TERM'">
            <elected-during-term :news="itemData"/>
          </template>
          <template v-else-if="newsType === 'ELECTED_RESUMED_DURING_TERM'">
            <elected-resumed-during-term :news="itemData"/>
          </template>
          <template v-else-if="newsType === 'ELECTED_RESIGNED_DURING_TERM'">
            <elected-resigned-during-term :news="itemData"/>
          </template>
          <template v-else-if="newsType === 'ELECTED_RESIGNED_REPLACED_DURING_TERM'">
            <elected-resigned-replaced-during-term :news="itemData"/>
          </template>
          <template v-else-if="newsType === 'ELECTED_VACATION_ENDED'">
            <elected-vocation-ended :news="itemData"/>
          </template>
          <template v-else-if="newsType === 'ELECTED_VACATION_STARTED'">
            <elected-vocation-started :news="itemData"/>
          </template>
          <template v-else-if="newsType === 'ELECTED_VAL_NEW'">
            <elected-val-new :news="itemData"/>
          </template>
          <template v-else-if="newsType === 'ELECTED_VAL_NEW_V2'">
            <elected-val-new-v2 :news="itemData"/>
          </template>
          <template v-else-if="newsType === 'ELECTED_VAL_RBTS'">
            <elected-val-rbts :news="itemData"/>
          </template>
          <template v-else-if="newsType === 'ELECTED_VAL_REVOKED'">
            <elected-val-revoked :news="itemData"/>
          </template>
          <template v-else-if="newsType === 'FORUM_CANDIDATE_VAL_LOST'">
            <forum-candidate-val-lost :news="itemData"/>
          </template>
          <template v-else-if="newsType === 'FORUM_CANDIDATE_VAL_NEW'">
            <forum-candidate-val-new :news="itemData"/>
          </template>
          <template v-else-if="newsType === 'FORUM_CANDIDATE_VAL_NEW_V2'">
            <forum-candidate-val-new-v2 :news="itemData"/>
          </template>
          <template v-else-if="newsType === 'FORUM_ELECTED_VAL_NEW'">
            <forum-elected-val-new :news="itemData"/>
          </template>
          <template v-else-if="newsType === 'FORUM_ELECTED_VAL_NEW_V2'">
            <forum-elected-val-new-v2 :news="itemData"/>
          </template>
          <template v-else-if="newsType === 'MEMBER_CREATED'">
            <member-created :news="itemData"/>
          </template>
          <template v-else-if="newsType === 'MEMBER_UPDATE_ABOUT'">
            <member-update-about :news="itemData"/>
          </template>
          <template v-else-if="newsType === 'MEMBER_UPDATE_ABOUT_EMPTY'">
            <member-update-about-empty :news="itemData"/>
          </template>
          <template v-else-if="newsType === 'MEMBER_UPDATE_AVATAR'">
            <member-update-avatar :news="itemData"/>
          </template>
          <template v-else-if="newsType === 'MEMBER_UPDATE_COVER'">
            <member-update-cover :news="itemData"/>
          </template>
          <template v-else-if="newsType === 'MEMBER_UPDATE_NAME'">
            <member-update-name :news="itemData"/>
          </template>
          <template v-else-if="newsType === 'MEMBER_UPDATE_WEBSITE'">
            <member-update-website :news="itemData"/>
          </template>
          <template v-else-if="newsType === 'MEMBER_UPDATE_WEBSITE_EMPTY'">
            <member-update-website-empty :news="itemData"/>
          </template>
          <template v-else-if="newsType === 'MEMBER_TURNED_INDEPENDENT'">
            <member-turned-independent :news="itemData"/>
          </template>
          <template v-else-if="newsType === 'MINISTER_NEW'">
            <minister-new :news="itemData"/>
          </template>
          <template v-else-if="newsType === 'MINISTER_REVOKED'">
            <minister-revoked :news="itemData"/>
          </template>
          <template v-else-if="newsType === 'OPINION_CHANGED_AND_MADE_PUBLIC_BY_MEMBER'">
            <opinion-changed-and-made-public-by-member :news="itemData"/>
          </template>
          <template v-else-if="newsType === 'OPINION_CHANGED_AND_MADE_PUBLIC_BY_ORG'">
            <opinion-changed-and-made-public-by-org :news="itemData"/>
          </template>
          <template v-else-if="newsType === 'OPINION_CHANGED_BY_MEMBER'">
            <opinion-changed-by-member :news="itemData"/>
          </template>
          <template v-else-if="newsType === 'OPINION_CHANGED_BY_ORG'">
            <opinion-changed-by-org :news="itemData"/>
          </template>
          <template v-else-if="newsType === 'OPINION_CREATED_BY_MEMBER'">
            <opinion-created-by-member :news="itemData"/>
          </template>
          <template v-else-if="newsType === 'OPINION_CREATED_BY_ORG'">
            <opinion-created-by-org :news="itemData"/>
          </template>
          <template v-else-if="newsType === 'OPINION_MEMBER_CONSOLIDATED'">
            <opinion-member-consolidated :news="itemData"/>
          </template>
          <template v-else-if="newsType === 'OPINION_NEW_MADE_PUBLIC_BY_MEMBER'">
            <opinion-new-made-public-by-member :news="itemData"/>
          </template>
          <template v-else-if="newsType === 'OPINION_NEW_MADE_PUBLIC_BY_ORG'">
            <opinion-new-made-public-by-org :news="itemData"/>
          </template>
          <template v-else-if="newsType === 'OPINION_UPDATED_BY_MEMBER'">
            <opinion-updated-by-member :news="itemData"/>
          </template>
          <template v-else-if="newsType === 'OPINION_UPDATED_BY_ORG'">
            <opinion-updated-by-org :news="itemData"/>
          </template>
          <template v-else-if="newsType === 'OPINION_UPDATED_AND_MADE_PUBLIC_BY_MEMBER'">
            <opinion-updated-and-made-public-by-member :news="itemData"/>
          </template>
          <template v-else-if="newsType === 'OPINION_UPDATED_AND_MADE_PUBLIC_BY_ORG'">
            <opinion-updated-and-made-public-by-org :news="itemData"/>
          </template>
          <template v-else-if="newsType === 'OPINION_CHANGED_BY_MEMBER_SPLIT'">
            <opinion-changed-by-member-split :news="itemData"/>
          </template>
          <template v-else-if="newsType === 'OPINION_CHANGED_BY_ORG_SPLIT'">
            <opinion-changed-by-org-split :news="itemData"/>
          </template>
          <template v-else-if="newsType === 'OPINION_GENERATED_BY_VOTING_MEMBER'">
            <opinion-generated-by-voting-member :news="itemData"/>
          </template>
          <template v-else-if="newsType === 'OPINION_GENERATED_BY_VOTING_ORG'">
            <opinion-generated-by-voting-org :news="itemData"/>
          </template>
          <template v-else-if="newsType === 'OPINION_ARCHIVED_MADE_PUBLIC'">
            <opinion-archived-made-public :news="itemData"/>
          </template>
          <template v-else-if="newsType === 'OPINION_MADE_PRIVATE'">
            <opinion-made-private :news="itemData"/>
          </template>
          <template v-else-if="newsType === 'ORG_CREATED'">
            <org-created :news="itemData"/>
          </template>
          <template v-else-if="newsType === 'ORG_CREATED_CONSOLIDATED'">
            <org-created-consolidated :news="itemData"/>
          </template>
          <template v-else-if="newsType === 'ORG_UPDATE_ABOUT'">
            <org-update-about :news="itemData"/>
          </template>
          <template v-else-if="newsType === 'ORG_UPDATE_AVATAR'">
            <org-update-avatar :news="itemData"/>
          </template>
          <template v-else-if="newsType === 'ORG_UPDATE_COVER'">
            <org-update-cover :news="itemData"/>
          </template>
          <template v-else-if="newsType === 'ORG_UPDATE_NAME'">
            <org-update-name :news="itemData"/>
          </template>
          <template v-else-if="newsType === 'ORG_UPDATE_WEBSITE'">
            <org-update-website :news="itemData"/>
          </template>
          <template v-else-if="newsType === 'PARTY_APPLICATION_RECEIVED'">
            <party-application-received :news="itemData"/>
          </template>
          <template v-else-if="newsType === 'PARTY_CREATED'">
            <PartyCreated :news="itemData"/>
          </template>
          <template v-else-if="newsType === 'PARTY_UPDATED_NAME'">
            <party-updated-name :news="itemData"/>
          </template>
          <template v-else-if="newsType === 'PARTY_UPDATED_WEBSITE'">
            <party-updated-website :news="itemData"/>
          </template>
          <template v-else-if="newsType === 'PRIME_MINISTER_NEW'">
            <prime-minister-new :news="itemData"/>
          </template>
          <template v-else-if="newsType === 'PROPOSAL_COMMITTEE_DECISION'">
            <proposal-committee-decision :news="itemData"/>
          </template>
          <template v-else-if="newsType === 'PROPOSAL_PUBLISH_BY_2'">
            <proposal-publish-by2 :news="itemData"/>
          </template>
          <template v-else-if="newsType === 'PROPOSAL_PUBLISH_BY_2_APPROVED'">
            <proposal-publish-by2-approved :news="itemData"/>
          </template>
          <template v-else-if="newsType === 'PROPOSAL_PUBLISH_BY_2_REFERRED'">
            <proposal-publish-by2-referred :news="itemData"/>
          </template>
          <template v-else-if="newsType === 'PROPOSAL_PUBLISH_BY_MEMBER'">
            <proposal-publish-by-member :news="itemData"/>
          </template>
          <template v-else-if="newsType === 'PROPOSAL_PUBLISH_BY_MEMBER_APPROVED'">
            <proposal-publish-by-member-approved :news="itemData"/>
          </template>
          <template v-else-if="newsType ==='PROPOSAL_PUBLISH_BY_MEMBER_REFERRED'">
            <proposal-publish-by-member-referred :news="itemData"/>
          </template>
          <template v-else-if="newsType === 'PROPOSAL_PUBLISH_BY_MULTIPLE'">
            <proposal-publish-by-multiple :news="itemData"/>
          </template>
          <template v-else-if="newsType === 'PROPOSAL_PUBLISH_BY_MULTIPLE_APPROVED'">
            <proposal-publish-by-multiple-approved :news="itemData"/>
          </template>
          <template v-else-if="newsType === 'PROPOSAL_PUBLISH_BY_MULTIPLE_REFERRED'">
            <proposal-publish-by-multiple-referred :news="itemData"/>
          </template>
          <template v-else-if="newsType === 'PROPOSAL_PUBLISH_BY_ORG'">
            <proposal-publish-by-org :news="itemData"/>
          </template>
          <template v-else-if="newsType === 'PROPOSAL_PUBLISH_BY_ORG_APPROVED'">
            <proposal-publish-by-org-approved :news="itemData"/>
          </template>
          <template v-else-if="newsType === 'PROPOSAL_PUBLISH_BY_ORG_REFERRED'">
            <proposal-publish-by-org-referred :news="itemData"/>
          </template>
          <template v-else-if="newsType === 'PROPOSAL_RIKSDAGEN_DECISION'">
            <proposal-riksdagen-decision :news="itemData"/>
          </template>
          <template v-else-if="newsType === 'PROPOSAL_SPLIT'">
            <proposal-split :news="itemData"/>
          </template>
          <template v-else-if="newsType === 'PROPOSAL_VOTING_PROVIDED'">
            <proposal-voting-provided :news="itemData"/>
          </template>
          <template v-else-if="newsType === 'PROPOSAL_TORCH_PASSED'">
            <proposal-torch-passed :news="itemData"/>
          </template>
          <template v-else-if="newsType === 'PROPOSAL_UPDATED_MAJOR'">
            <proposal-updated-major :news="itemData"/>
          </template>
          <template v-else-if="newsType === 'PROPOSAL_UPDATED_MINOR'">
            <proposal-updated-minor :news="itemData"/>
          </template>


          <!--CONSOLIDATED-->
          <template v-else-if="newsType === 'CANDIDATE_VAL_NEW_CONSOLIDATED'">
            <candidate-val-new-consolidated :news="itemData"/>
          </template>
          <template v-else-if="newsType === 'ELECTED_VAL_NEW_CONSOLIDATED'">
            <elected-val-new-consolidated :news="itemData"/>
          </template>
          <template v-else-if="newsType === 'MEMBER_CREATED_CONSOLIDATED'">
            <member-created-consolidated :news="itemData"/>
          </template>
          <template v-else-if="newsType === 'OPINION_ORG_CONSOLIDATED'">
            <opinion-org-consolidated :news="itemData"/>
          </template>
          <template v-else-if="newsType === 'PARTY_APPLICATION_RECEIVED_CONSOLIDATED'">
            <party-application-received-consolidated :news="itemData"/>
          </template>
          <template v-else-if="newsType === 'PARTY_CREATED_CONSOLIDATED'">
            <party-created-consolidated :news="itemData"/>
          </template>
          <template v-else-if="newsType === 'PARTY_UPDATED_NAME_CONSOLIDATED'">
            <party-updated-name-consolidated :news="itemData"/>
          </template>
          <template v-else-if="newsType === 'PARTY_UPDATED_WEBSITE_CONSOLIDATED'">
            <party-updated-website-consolidated :news="itemData"/>
          </template>
          <template v-else-if="newsType === 'PROPOSAL_PUBLISH_BY_2_CONSOLIDATED'">
            <proposal-publish-by2-consolidated :news="itemData"/>
          </template>
          <template v-else-if="newsType ==='PROPOSAL_PUBLISH_BY_MEMBER_CONSOLIDATED'">
            <proposal-publish-by-member-consolidated :news="itemData"/>
          </template>
          <template v-else-if="newsType ==='PROPOSAL_PUBLISH_BY_MULTIPLE_CONSOLIDATED'">
            <proposal-publish-by-multiple-consolidated :news="itemData"/>
          </template>
          <template v-else-if="newsType ==='PROPOSAL_PUBLISH_BY_ORG_CONSOLIDATED'">
            <proposal-publish-by-org-consolidated :news="itemData"/>
          </template>
          <template v-else-if="newsType ==='PROPOSAL_PUBLISH_BY_MEMBER_CONSOLIDATED_DIFFERENT'">
            <proposal-publish-by-member-consolidated-different :news="itemData"/>
          </template>
          <template v-else-if="newsType === 'PROPOSAL_PUBLISH_BY_ORG_CONSOLIDATED_DIFFERENT'">
            <proposal-publish-by-org-consolidated-different :news="itemData"/>
          </template>
          <template v-else-if="newsType === 'PROPOSAL_COMMITTEE_DECISION_CONSOLIDATED'">
            <proposal-committee-decision-consolidated :news="itemData"/>
          </template>
          <template v-else-if="newsType === 'PROPOSAL_RIKSDAGEN_DECISION_CONSOLIDATED'">
            <proposal-riksdagen-decision-consolidated :news="itemData"/>
          </template>
          <template v-else>
            <div v-html="itemData.text">
            </div>
          </template>
        </div>
        <div class="news-information">
          <span class="news-date">{{ itemData.date }}</span>
          <span :class="privacyIcon"></span>
        </div>
      </div>
    </div>
<!--    <div class="news-footer">-->

<!--    </div>-->
  </div>
</template>

<style lang="scss">
.news-wrapper {
  position: relative;
  margin-bottom: 10px;
  font-size: 14px;
  background-color: #fff;
  overflow: visible;

  .news-element {
    display: flex;
    padding: 12px;

    .user-news-avatar {
      margin-right: 10px;
    }

    .news-content {
      display: block;
      text-align: left;
      overflow: hidden;

      .news-text {
        max-width: 496px;
        margin-bottom: 9px;
        line-height: 1.42;

        a {
          font-weight: 600;
        }
      }

      .news-information {
        font-size: 12px;
        color: #bbb;
        padding-bottom: 3px;

        .news-date {
          display: inline-block;

          &:after {
            content: "•";
            display: inline-block;
            margin: 0 4px;
          }
        }

        .PUBLIC-news-privacy {
          position: relative;
          top: 2px;
          display: inline-block;
          width: 13px;
          height: 13px;
          background: url("~@/assets/img/news/public-news.svg") no-repeat;
          background-size: cover;
        }

        .PRIVATE-news-privacy {
          display: inline-block;
          width: 10px;
          height: 13px;
          background: url("~@/assets/img/news/private-news.svg") no-repeat;
          background-size: cover;
        }
      }
    }
  }

  .news-footer {
    padding: 5px 12px 4px;
    background: #f2f2f2;
    position: relative;
  }
}

</style>